/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Delete_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to delete the promo" |
*
* @param {Promo_Delete_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_delete_failed = /** @type {((inputs?: Promo_Delete_FailedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Delete_FailedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la suppression de la promo")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al eliminar la promo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao excluir a promo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eliminazione della promo fallita")
	return /** @type {LocalizedString} */ ("Failed to delete the promo")
});